var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeWidth: 1.167,
  d: "m11.559 13.168-.001.001a14.32 14.32 0 0 1-2.519 2.22.344.344 0 0 1-.018.01 14.275 14.275 0 0 1-3.62-3.578 7.296 7.296 0 0 1-1.317-3.95l.003-.206C4.154 5.83 5.102 4.17 6.578 3.27a4.617 4.617 0 0 1 4.91.04c1.505.983 2.436 2.747 2.429 4.663-.037 1.898-1.04 3.734-2.358 5.195ZM9.95 5.613c-.932-.415-2-.183-2.7.562a2.677 2.677 0 0 0-.527 2.784c.369.953 1.254 1.605 2.268 1.606a2.38 2.38 0 0 0 1.75-.762 2.634 2.634 0 0 0 .704-1.81c.002-1.02-.571-1.968-1.495-2.38Z"
})));
export default SvgIconPin;